import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout";
import PaymentPage from "./findPage/paymentPage";
import SettlementRequest from "./findPage/settlementRequest";
import SettlementHistory from "./findPage/settlementHistory";
import SettlmentRegisterHistoryDetail from "../supplierPayment/detailFiles/settlmentRegisterHistoryDetail";
import PaymentRequestInfo from "../supplierPayment/detailFiles/paymentRequest";
import TablePaymentSettlmentInfo from "../supplierPayment/detailFiles/tablePaymentSettlmentInfo";
import ChequeProsses from "../chequeProsses/ChequeProsses";

export default function PaymentConfigPage() {
  const active = localStorage.getItem("setActivePage");
  return (
    <Switch>
      {
        /* Redirect from eCommerce root URL to /customers */
        <Redirect exact={true} from="/Payment" to={`/Payment/${active}`} />
      }

      <ContentRoute
        path="/Payment/SettlementWithReceiver"
        component={PaymentPage}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Payment/SettlementRequestsBySupplier"
        component={SettlementRequest}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Payment/PaymentSettlementHistory"
        component={SettlementHistory}
        label={undefined}
        children={undefined}
        render={undefined}
      />

      <ContentRoute
        path="/Payment/SettlmentRegisterDetail"
        component={TablePaymentSettlmentInfo}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Payment/SettlmentRegisterHistoryDetail"
        component={TablePaymentSettlmentInfo}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Payment/PaymentRequestInfo"
        component={PaymentRequestInfo}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Payment/ChequeProcess"
        component={ChequeProsses}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      {/* <ContentRoute
        path="/Payment/:activePage1/request-find-detail"
        component={RequestFindDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      /> */}
    </Switch>
  );
}
